var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"background"},[_c('title-bar'),_c('home-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }